module.exports = __webpack_public_path__ + "static/img/m17.2135b61.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spark2/mobile/m17.png
// module id = y6ak
// module chunks = 12